import React from 'react'
import { AlertCircle } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface ErrorStateProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  description?: string
  action?: {
    label: string
    onClick: () => void
  }
  variant?: 'default' | 'card'
}

export function ErrorState({
  title = 'Error',
  description = 'Something went wrong. Please try again.',
  action,
  variant = 'default',
  className,
  ...props
}: ErrorStateProps) {
  const content = (
    <>
      <Alert 
        variant="destructive" 
        className="max-w-md border-destructive/50 bg-destructive/10"
      >
        <AlertCircle className="h-4 w-4" />
        <AlertTitle className="font-semibold text-destructive">
          {title}
        </AlertTitle>
        <AlertDescription className="text-destructive/90">
          {description}
        </AlertDescription>
      </Alert>
      {action && (
        <Button 
          variant="outline" 
          onClick={action.onClick}
          className="mt-4"
        >
          {action.label}
        </Button>
      )}
    </>
  )

  if (variant === 'card') {
    return (
      <Card
        className={cn(
          'flex flex-col items-center justify-center',
          'min-h-[200px] p-8',
          className
        )}
        {...props}
      >
        {content}
      </Card>
    )
  }

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center',
        'min-h-[200px] p-8',
        className
      )}
      {...props}
    >
      {content}
    </div>
  )
}